"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_VEHICLES = 'LOAD_VEHICLES';
exports.LOAD_VEHICLE = 'LOAD_VEHICLE';
exports.CREATE_VEHICLE = 'CREATE_VEHICLE';
exports.UPDATE_VEHICLE = 'UPDATE_VEHICLE';
exports.SELECT_VEHICLE = 'SELECT_VEHICLE';
exports.ADD_VEHICLE_PERMISSION = 'ADD_VEHICLE_PERMISSION';
exports.REMOVE_VEHICLE_PERMISSION = 'REMOVE_VEHICLE_PERMISSION';
exports.SET_VEHICLE_ACCESSIBILITY = 'SET_VEHICLE_ACCESSIBILITY';
exports.SET_VEHICLE_ORGANIZATION = 'SET_VEHICLE_ORGANIZATION';
exports.ADD_VEHICLE_RELATION = 'ADD_VEHICLE_RELATION';
exports.REMOVE_VEHICLE_RELATION = 'REMOVE_VEHICLE_RELATION';
exports.LOAD_PUBLIC_VEHICLES = 'LOAD_PUBLIC_VEHICLES';
exports.LOAD_PUBLIC_VEHICLE = 'LOAD_PUBLIC_VEHICLE';
exports.LOAD_REALESTATES = 'LOAD_REALESTATES';
exports.LOAD_REALESTATE = 'LOAD_REALESTATE';
exports.CREATE_REALESTATE = 'CREATE_REALESTATE';
exports.UPDATE_REALESTATE = 'UPDATE_REALESTATE';
exports.SELECT_REALESTATE = 'SELECT_REALESTATE';
exports.ADD_REALESTATE_PERMISSION = 'ADD_REALESTATE_PERMISSION';
exports.REMOVE_REALESTATE_PERMISSION = 'REMOVE_REALESTATE_PERMISSION';
exports.SET_REALESTATE_ACCESSIBILITY = 'SET_REALESTATE_ACCESSIBILITY';
exports.SET_REALESTATE_ORGANIZATION = 'SET_REALESTATE_ORGANIZATION';
exports.ADD_REALESTATE_RELATION = 'ADD_REALESTATE_RELATION';
exports.REMOVE_REALESTATE_RELATION = 'REMOVE_REALESTATE_RELATION';